import React from "react"
import ProgressiveImage from "react-progressive-image"
import styled from "styled-components"
import { Text, Image } from "rebass"
import PropTypes from "prop-types"

import placeholder from "./placeholder.jpg"

const Card = styled.div`
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 5px;
  &:hover {
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
  }
`

const Img = styled(Image)`
  border-radius: 5px 5px 0 0;
`

const Anchor = styled.a.attrs({
  href: props => props.url || "https://google.com",
  target: "_blank"
})``

const Container = styled.div`
  padding: 2px 16px;
`

const Item = ({ data, url }) => (
  <Card>
    <Anchor url={url}>
      <ProgressiveImage placeholder={placeholder} src={data.imageUrl}>
        {src => <Img style={{ height: 599, width: 599 }} src={src} />}
      </ProgressiveImage>
    </Anchor>
    <Container>
      <Text my={1} fontSize={[0, 1, 2, 3]} fontWeight="bold" textAlign="center">
        {data.name}
      </Text>
      <Text my={1} fontSize={[0, 1, 2, 3]} textAlign="center">
        {data.price} vnd
      </Text>
    </Container>
  </Card>
)

Item.propTypes = {
  data: PropTypes.shape({
    price: PropTypes.string,
    name: PropTypes.string,
    imageUrl: PropTypes.string
  }).isRequired,
  url: PropTypes.string.isRequired
}

export default Item



// WEBPACK FOOTER //
// ./src/components/Item/index.js